<ngx-loading-bar
  [fixed]="true"
  [height]="'4px'"
  [color]="'#4EC4CC'"
  [includeSpinner]="false"
></ngx-loading-bar>
<!-- <preloader /> -->
<router-outlet></router-outlet>
